import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import { MenuManagementBrandCategory } from '@/pages/menu-managements/categories/service';
import { MenuManagementBrandCategoryService } from '@/services/BrandCategory/MenuManagementBrandCategoryService';
import { MenuManagementListQueryParams } from '@/services/Service/MenuManagementList';

export type MenuManagementCategoryListParams = MenuManagementListQueryParams;

export type CategoryListResponse = {
  categories: MenuManagementBrandCategory[];
  count: number;
};

export const useMenuManagementBrandCategoryList = async (
  params: MenuManagementCategoryListParams
): Promise<CategoryListResponse> => {
  const menuManagementBrandCategoryService =
    new MenuManagementBrandCategoryService(getClient());
  try {
    const res = await menuManagementBrandCategoryService.list(params);
    return res;
  } catch (error) {
    // @ts-ignore TS2322
    return errorHandler({ error });
  }
};
